import React, { createElement, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Immutable from 'immutable'
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes'
import { clearLegalManifestTickets, getLegalManifestTickets } from '../../../actions/legal/LegalManifestTickets'
import Content from '../../layout/Content'
import LegalManifestTicketForm from './legal-cargo/LegalManifestTicketForm'
import { tzNormalizeDate } from '../../../utils/date'
import { INT_DATE_FORMAT } from '../../../config/locale'
import Table from '../../common/Table'
import { generateManifestTicketColumns } from '../../../config/columns'
import { DEFAULT_PAGE_SIZE, LEGAL_SOURCE_SYSTEM } from '../../../config/constants'
import LegalManifestTicket from './legal-cargo/LegalManifestTicket'
import { generateManifestTicketFile, getManifestTicketExportExcel } from '../../../actions/legal/LegalManifestTicket'

const LegalManifestTickets = ({
  breadcrumbs,
  loading,
  legalManifestTickets,
  dispatchGetLegalManifestTickets,
  dispatchClearLegalManifestTickets,
  dispatchGetManifestTicketExportExcel,
  dispatchGenerateManifestTicketFile
}) => {

  useEffect(() => () => dispatchClearLegalManifestTickets(), [])

  const handleSubmit = (formValues) => {
    dispatchClearLegalManifestTickets()

    const { fromDateString, toDateString, busLicensePlate } = formValues;
    const startDate = tzNormalizeDate({
      date: fromDateString,
      format: INT_DATE_FORMAT,
    });
    const endDate = tzNormalizeDate({
      date: toDateString,
      format: INT_DATE_FORMAT,
    });

    const newFormValues = {
      licensePlate: busLicensePlate,
      startDate,
      endDate,
    }

    if (formValues.sourceCity) {
      newFormValues.sourceCityId = formValues.sourceCity.value;
    }

    if (formValues.destinationCity) {
      newFormValues.destinationCityId = formValues.destinationCity.value;
    }

    dispatchGetLegalManifestTickets({ ...newFormValues })
  }

  const handleAction = ({ original: { idSourceSystem, flitItineraryId } }) => {
    if (!idSourceSystem) {
      return;
    }
    const system = idSourceSystem.split('-')[0];
    if (system === LEGAL_SOURCE_SYSTEM.OLD.value) {
      dispatchGetManifestTicketExportExcel(idSourceSystem)
    }
    if (system === LEGAL_SOURCE_SYSTEM.FLIT.value) {
      dispatchGenerateManifestTicketFile(flitItineraryId)
    }
  }

  const renderManifestDetailComponent = ({ original }) => {
    const component = createElement(LegalManifestTicket, {
      idSourceSystem: original.idSourceSystem,
    })
    return (
      <div className="mt-3 mb-2 ml-5 mr-5">
        {component}
      </div>
    );
  }

  const content = (
    <>
      <LegalManifestTicketForm onSubmit={handleSubmit} loading={loading} />
      <h3>Resultados de la búsqueda</h3>
      <Table
        manual={false}
        columns={generateManifestTicketColumns(handleAction)}
        data={legalManifestTickets.toJS()}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        rowComponent={renderManifestDetailComponent}
        loading={loading}
      />
    </>
  )
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Manifiesto de Pasajeros"
      content={content}
    />
  )
}

LegalManifestTickets.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  legalManifestTickets: PropTypes.instanceOf(Immutable.List).isRequired,
  dispatchGetLegalManifestTickets: PropTypes.func.isRequired,
  dispatchClearLegalManifestTickets: PropTypes.func.isRequired,
  dispatchGetManifestTicketExportExcel: PropTypes.func.isRequired,
  dispatchGenerateManifestTicketFile: PropTypes.func.isRequired,
}

LegalManifestTickets.defaultProps = {
  loading: false,
}

const mapStateToProps = ({ LegalUnit }) => ({
  breadcrumbs: [
    ...LegalUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Manifiesto de Pasajeros',
      href: '',
    },
  ],
  loading: LegalUnit.LegalManifestTicket.getIn(['all', 'loading']),
  legalManifestTickets: LegalUnit.LegalManifestTicket.getIn(['all', 'content']),
});

const mapDispatchToProps = {
  dispatchGetLegalManifestTickets: getLegalManifestTickets,
  dispatchClearLegalManifestTickets: clearLegalManifestTickets,
  dispatchGetManifestTicketExportExcel: getManifestTicketExportExcel,
  dispatchGenerateManifestTicketFile: generateManifestTicketFile
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LegalManifestTickets);
